/**
 * @Description: test模块路由
 * @Date: 2022-11-26
 * @LastEditTime: 2022-11-26
 */
import { RoutesTypeNew } from '@/types/routes'
import { UserSwitchOutlined } from '@ant-design/icons'

const product: RoutesTypeNew = [
  {
    path: 'industry',
    component: () => import(/* webpackChunkName: "product-index" */ '@/views/industry/index'),
    meta: {
      title: '行业应用',
      icon: <UserSwitchOutlined />,
      noLogin: true,
    },
  },
  {
    path: 'industry/detail/:id',
    component: () => import(/* webpackChunkName: "thermometer" */ '@/views/industry/detail'),
    meta: {
      title: '产品详情',
      noLogin: true,
    },
  },
]

export default product
